/* unplugin-vue-components disabled */import { render } from "./alert-banner.vue?vue&type=template&id=6667566d&scoped=true"
import script from "./alert-banner.vue?vue&type=script&lang=js"
export * from "./alert-banner.vue?vue&type=script&lang=js"

import "./alert-banner.vue?vue&type=style&index=0&id=6667566d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6667566d"],['__file',"src/controls/alert-banner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6667566d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6667566d', __exports__)) {
    api.reload('6667566d', __exports__)
  }
  
  module.hot.accept("./alert-banner.vue?vue&type=template&id=6667566d&scoped=true", () => {
    api.rerender('6667566d', render)
  })

}


export default __exports__